<!--
 * @Author: wzh
 * @LastEditTime: 2024-12-17 18:03:12
 * @Description: 头部
-->
<template>
  <header class="layout-title">
    <div>
      <!-- <a-input-search placeholder="搜索应用名" @search="() => $emit('onSearch')" class="input-search" /> -->
    </div>
    <div class="right">
      <div>
        <div class="portrait" v-if="isHB">
          <img :src="portrait || defaultPort" alt="" />
        </div>
        <span style="margin-left: 10px"
          >{{ $t("home.welcome") }} {{ displayName }}</span
        >
      </div>
      <div>
        <!-- author: lcy, date: 2023-09-18 2023-09-18 22:12:16, for: 眭总要求 暂时关闭中英文切换 -->
        <!-- <a-dropdown>
					<a class="ant-dropdown-link" style="color: #040849">{{ currentLanguage }} <a-icon type="down"/></a>
					<a-menu slot="overlay">
						<a-menu-item @click="languageChange('zh')">简体中文</a-menu-item>
						<a-menu-item @click="languageChange('en')">English</a-menu-item>
					</a-menu>
				</a-dropdown> -->
      </div>

      <div>
        <img
          src="@/assets/images/layout/user_tuichu.png"
          alt=""
          @click="loginOut"
          class="login-out"
        />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { commonAPI } from "@/apis";
import defaultPort from "@/assets/images/layout/user_photo.png";
import { currentLanguage } from "@/utils/helpers";
import {
	readCookie,
	parseUserCookie,
	hasValidRememberMe,
} from "@/utils/authSession";

export default {
  computed: {
    ...mapGetters("auth", ["token", "user"]),
  },
  data() {
    return {
      defaultPort,
      portrait: "",
      currentLanguage: "简体中文",
      displayName: "",
    };
  },
  created() {
    this.isHB = process.env.VUE_APP_ISHB == 1 ? true : false;
    this.currentLanguage = currentLanguage(true).text;
    const user = this.$store.getters["auth/user"] || {};
    const cookieUser = parseUserCookie(readCookie("user")) || {};
    const rememberUser =
      (hasValidRememberMe(this.$cookies) &&
        this.$cookies.get("REMEMBER_ME") &&
        this.$cookies.get("REMEMBER_ME").user) ||
      {};
    this.displayName =
      user.displayName ||
      user.username ||
      cookieUser.displayName ||
      cookieUser.username ||
      rememberUser.displayName ||
      rememberUser.username ||
      "";
    this.getList();
  },
  methods: {
    // 得到个人基本信息
    async getList() {
      const { code, data } = await commonAPI.getAction("/config/profile/get");
      if (code == 0) {
        this.portrait = data.pictureBase64 || "";
      }
    },
    // 退出登录
    loginOut() {
      this.$confirm({
        title: this.$t("base.prompt.confirm_title"),
        content: this.$t("base.prompt.login_out"),
        onOk: () => {
          this.$store.dispatch("auth/loginOut");
        },
      });
    },
    // author: wzh, date: 2023-01-06, for: 语言切换
    languageChange(type) {
      let obj =
        type == "zh"
          ? { value: "zh", text: "简体中文" }
          : { value: "en", text: "English" };
      this.currentLanguage = obj.text;
      this.$i18n.locale = type;
      localStorage.setItem("language", JSON.stringify(obj));
      this.$bus.emit("change_lang");
    },
  },
};
</script>

<style lang="less" scoped>
// ############################################################头部组件样式#########################################################
.layout-title {
  display: flex;
  justify-content: space-between;
  padding: 15px 40px 15px 0;
  color: #040849;
  font-size: 14px;
  .input-search {
    ::v-deep .ant-input {
      border-radius: 24px;
    }
  }
  .right {
    display: flex;
    align-content: center;
    & > div {
      margin-left: 45px;
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
    }
    .login-out {
      cursor: pointer;
    }
    .portrait {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      overflow: hidden;
      & > img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
